var blake = require('blakejs');
/**
 * computes blake2b 256bit hash of given data
 * @param data one or more Buffer | string
 */


export function blake2b256() {
  var ctx = blake.blake2bInit(32, null);

  for (var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++) {
    data[_key] = arguments[_key];
  }

  data.forEach(function (d) {
    if (Buffer.isBuffer(d)) {
      blake.blake2bUpdate(ctx, d);
    } else {
      blake.blake2bUpdate(ctx, Buffer.from(d, 'utf8'));
    }
  });
  return Buffer.from(blake.blake2bFinal(ctx));
}